<template>
    <!-- 对话框 -->
    <el-dialog title="编辑商家" :visible.sync="show" :modal="false" :before-close="closeDialog" class="dialog">

        <!-- 基本信息表单 -->
        <div class="form-box">
            <el-form label-width="80px">

                <el-form-item label="商家名称:" label-width='130px'>
                    <el-input v-model="submit_data.name" style="width: 160px;">
                    </el-input>
                </el-form-item>


                <el-form-item label="手机号:" label-width='130px'>
                    <el-input v-model="submit_data.phone" disabled style="width: 160px;" maxlength="11">
                    </el-input>
                </el-form-item>


                <el-form-item label="商家状态:" label-width='130px'>
                    <el-select
                            v-model="submit_data.status"
                            clearable
                            style="position: relative;width: 200px;margin-right: 5px;"
                    >
                        <el-option label="有效" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>

                    </el-select>
                </el-form-item>



            </el-form>

            <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
                <el-button type="primary" @click="editBusiness">保存</el-button>
                <el-button @click="closeDialog">关闭</el-button>
            </div>

        </div>

    </el-dialog>
</template>

<script>
    var _this;

    export default {
        props: {
            'isShow': Boolean,
            'data':''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;
                _this.submit_data.phone = _this.data;
                _this.$post(
                    '/activity/getBusiness',
                    {
                        phone:_this.submit_data.phone
                    }
                ).then(res => {


                    _this.submit_data.phone = res.data.phone;
                    _this.submit_data.name = res.data.name;
                    _this.submit_data.status = res.data.status;


                }).catch((err) => {

                })

            },

        },
        data() {
            return {

                show: false,



                // 表单提交数据
                submit_data: {
                    name: '',
                    phone: '',
                    status:''
                },



            };
        },
        created() {
            _this = this;

        },
        methods: {

            // 关闭方法
            closeDialog() {

                _this.show = false;

                _this.submit_data = {
                    name: '',
                    phone: '',
                    status:'0'
                }
            },

            // 提交按钮
            editBusiness() {

                _this.$post(
                    '/activity/editBusiness',
                    _this.submit_data
                ).then(res => {


                        _this.$message.success(res.msg);

                        _this.closeDialog();

                        _this.$emit('onSubmit');


                }).catch((err) => {

                })

            },

        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }
    .dialog{
        width:1000px;
        margin: 5vh auto 0;
    }
</style>
